// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionE_comp__qh8JQ"};